/**
 * BookingPageSkeleton: the booking page's one loading state (CC 0304, 0337, 0338). It draws
 * booking-page-ghost's markup, which manage.html also paints from first paint, so the boot shell,
 * the exchange and the page read are one unchanging placeholder until the page replaces it.
 */
import type { JSX } from "react";
import { GHOST_CSS, GHOST_HTML } from "./booking-page-ghost";

export function BookingPageSkeleton({ label }: { label: string }): JSX.Element {
  /* The screen-reader line follows the surface's string; the shape is the shared markup. */
  const html = GHOST_HTML.replace("Opening your booking…", label);
  return (
    <>
      <style>{GHOST_CSS}</style>
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </>
  );
}
